import { Layout } from "@/components/Layout";
import { MySouvenirs } from "@/components/souvenirs/MySouvenirs";

export default function MySouvenirsPage() {
  return (
    <Layout>
      <div className="max-w-4xl animate-fade-up" data-testid="my-souvenirs-page">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">My Membership</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-1">My Souvenirs</h1>
        <p className="text-sm text-muted-foreground mt-3">See the souvenirs allocated to you and confirm when you receive them.</p>
        <MySouvenirs standalone />
      </div>
    </Layout>
  );
}
